'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ReactModal = require('react-modal');
const tokenReplace = require('dibs-token-replace');

const ContextComponent = require('../ContextComponent');
const SanitizeHtml = require('../SanitizeHtml');
const styles = require('./tradeWelcomeMessage.scss');
const AccountFilledIcon = require('dibs-vg/dist/react/account-filled');
const ArrowUpIcon = require('dibs-vg/dist/react/arrow-up');
const CloseIcon = require('dibs-vg/dist/react/close');
const classNames = require('classnames');
const copy = require('./tradeWelcomeMessageCopy.json');

const tradeMessageActions = require('../../actions/tradeMessageActions');
const Tour = require('../../../components/Tour/Tour');
const tourTracking = require('../../tracking/tourTracking');
const tradeWelcomeMessageTracking = require('./tradeWelcomeMessageTracking');

class TradeWelcomeMessage extends ContextComponent {

    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
            isVisible: !props.tradeTour.isTourOpen && props.isVisible
        };

        this.toggleExpand = this.toggleExpand.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    componentDidMount() {
        if (this.state.isVisible) {
            tradeWelcomeMessageTracking.trackOpen();
        }
    }

    componentWillReceiveProps({isVisible, tradeTour}) {
        const isLastStep = tradeTour.currentStep === tradeTour.totalSteps;
        if (tradeTour.isTourOpen && isLastStep) {
            this.setState({isVisible: true});
        } else if (tradeTour.isTourOpen) {
            this.setState({isVisible: false});
        } else {
            this.setState({isVisible});
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.isVisible && !this.state.isVisible) {
            tradeWelcomeMessageTracking.trackOpen();
        }
    }

    toggleExpand() {
        const isExpanded = !this.state.isExpanded;

        this.setState({isExpanded});

        if (isExpanded) {
            tradeWelcomeMessageTracking.trackExpand();
        }
    }

    onCloseClick() {
        this.context.executeAction(tradeMessageActions.hideTradeMessage);
        tradeWelcomeMessageTracking.trackClose();
    }

    getCollapsedContent() {
        const {firstName: repFirstName} = this.props.tradeSalesRep;
        const content = tokenReplace(copy.collapsed, {
            repFirstName,
            repClass: styles.collapsedName
        });
        return (
            <div onClick={this.toggleExpand} className={styles.collapsedContent}>
                <SanitizeHtml content={content} allowedTags={['span']} allowedAttributes={{span: ['class']}} />
            </div>
        );
    }

    getExpandedContent() {
        const props = this.props;
        const {tradeSalesRep, userFirstName} = props;
        const {firstName: repFirstName} = tradeSalesRep;
        const showFirstName = userFirstName ? <div className={`${styles.expandedTitle} ${styles.paragraph}`}>{userFirstName + ','}</div> : null;
        const displayName = `${tradeSalesRep.firstName} ${tradeSalesRep.lastName}`;
        return (
            <div className={styles.content}>
                {showFirstName}
                {copy.expanded.map((text, index) => <div key={index} className={styles.paragraph}>{tokenReplace(text, {repFirstName})}</div>)}
                <div>{displayName}</div>
                <div>{tradeSalesRep.phoneNumber}</div>
                <div>{tradeSalesRep.email}</div>
            </div>
        );
    }

    onOpenWelcomeMessageTour(payload) {
        tourTracking.trackOpen(payload);
        tourTracking.trackComplete(payload);
    }

    includeTour() {
        const {isTourOpen} = this.props.tradeTour;
        if (isTourOpen) {
            return (
                <Tour dataTn="welcome-message-trade" step={6} {...this.props.tradeTour} onOpen={this.onOpenWelcomeMessageTour}>
                    <div className={styles.pictureTourWrapper}>
                        <AccountFilledIcon className={styles.picture} />
                    </div>
                </Tour>
            );
        }
        return <AccountFilledIcon className={styles.picture} />;
    }

    render() {
        const {isVisible, isExpanded} = this.state;
        const {userFirstName} = this.props;
        const {modalOverlay: overlayClassName} = styles;
        const expandedClassName = userFirstName ? styles.isExpanded : styles.isExpandedNoName;
        const modalClassName = classNames(styles.modalContent, {
            [expandedClassName]: isExpanded
        });
        const toggleClass = classNames(styles.icon, {
            [styles.flip]: isExpanded
        });

        return (
            <ReactModal isOpen={isVisible} overlayClassName={overlayClassName} className={modalClassName}>
                <div className={styles.iconWrapper}>
                    <a href="#0" onClick={this.toggleExpand}>
                        <ArrowUpIcon className={toggleClass} />
                    </a>
                    <a href="#0" onClick={this.onCloseClick}>
                        <CloseIcon className={styles.icon} />
                    </a>
                </div>
                {isExpanded ? this.getExpandedContent() : this.getCollapsedContent()}
                <div className={styles.pictureWrapper}>
                    {this.includeTour()}
                </div>
            </ReactModal>
        );
    }
}

TradeWelcomeMessage.propTypes = {
    userFirstName: PropTypes.string,
    tradeSalesRep: PropTypes.object.isRequired,
    tradeTour: PropTypes.object,
    step: PropTypes.number
};


TradeWelcomeMessage.defaultProps = {
    tradeTour: {
        isTourOpen: false
    }
};

module.exports = TradeWelcomeMessage;



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeWelcomeMessage/TradeWelcomeMessage.jsx